
import { computed, defineComponent, PropType } from 'vue';
import CMSLinkHandler from '@/shared/content/blocks/helpers/CMSLinkHandler.vue';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';
import { CallToActionTileModel } from '@/types/B2BcontentServerContract';

export default defineComponent({
    name: 'CallToActionFullWidthLayout',
    components: { MediaHandler, CMSLinkHandler },
    props: {
        content: {
            type: Object as PropType<CallToActionTileModel>,
            required: true,
        },
    },
    setup(props) {
        const aspectRatio = { xs: 5 / 6, sm: 1 / 1, default: 2 / 1 };

        const mediaTileContentBlock = computed(() => {
            return props.content.tiles[0].model;
        });

        return {
            aspectRatio,
            mediaTileContentBlock,
        };
    },
});
